import React from "react";
import { Grid } from "@mui/material";
import { Formik } from "formik";

import FileComponent from "./FileComponent";

export default function FileDialog({ formikProps }) {
  var dynamicField = formikProps.values;

  return (
    <Grid size={12}>
      <Formik initialValues={dynamicField} enableReinitialize validateOnMount>
        {(dialogFormikProps) => (
          <FileComponent
            formikProps={dialogFormikProps}
            fieldDetails={dialogFormikProps.values}
            disabled={!dialogFormikProps.values.editable}
          />
        )}
      </Formik>
    </Grid>
  );
}
